import { AdyenPaymentMethodType } from "../Transaction";

export enum PaymentsIntegrationEnum {
  Quickbooks = "quickbooks",
  Xero = "xero"
}

export enum PaymentsIntegrationStatusEnum {
  Ready = "ready",
  Connecting = "connecting",
  Error = "error"
}

export enum PaymentsIntegrationTypeEnum {
  Accounting = "accounting"
}

export interface PaymentsIntegrationView {
  id: number;
  team_id: number;
  integration: PaymentsIntegrationEnum;
  status: PaymentsIntegrationStatusEnum;
  type: PaymentsIntegrationTypeEnum;
  error?: string;
  created_at: Date;
  updated_at: Date;
  re_authorization_required: boolean;
  re_authorization_banner_message?: string;
}

export interface QuickBooksKeyValueView {
  key: string;
  display_value: string;
}

export interface PaymentMethodsView {
  zomentum_payment_methods: QuickBooksKeyValueView[];
  quickbooks_payment_methods: QuickBooksKeyValueView[];
}

export interface QuickbooksConfigurationView {
  zomentum_payment_key: QuickBooksKeyValueView;
  quickbook_options: QuickBooksKeyValueView[];
}

export interface XeroConfigurationView {
  zomentum_payment_key: QuickBooksKeyValueView;
  xero_options: QuickBooksKeyValueView[];
}

export interface QuickBooksMetaDataView {
  vendors: QuickbooksConfigurationView;
  expense_accounts: QuickbooksConfigurationView;
  income_accounts: QuickbooksConfigurationView;
  payout_bank_accounts: QuickbooksConfigurationView;
  payment_methods: PaymentMethodsView;
}

export interface XeroMetaDataView {
  suppliers: XeroConfigurationView;
  expense_accounts: XeroConfigurationView;
  income_accounts: XeroConfigurationView;
  payout_bank_accounts: XeroConfigurationView;
}

export interface QuickBookConfigurationView {
  id: number;
  team_id: number;
  key: string;
  value: string;
  created_at: Date;
  updated_at: Date;
}

export interface PaymentsIntegrationsMethodMappingView {
  id: number;
  team_id: number;
  payment_integration: PaymentsIntegrationEnum;
  partner_configured_payment_method: string;
  payment_integration_ref: number;
  created_at: Date;
  updated_at: Date;
}

export interface QuickBookMappingView {
  configuration: QuickBookConfigurationView[];
  payment_method: PaymentsIntegrationsMethodMappingView[];
}

export interface QuickBookConfigurationSettingRequest {
  zomentum_key: string;
  quickbook_key: string;
}

export interface PaymentsIntegrationsMethodMappingRequest {
  payment_integration_ref: number;
  partner_configured_payment_method: AdyenPaymentMethodType;
}

export interface QuickbooksSettingsRequest {
  configuration: QuickBookConfigurationSettingRequest[];
  payment_method: PaymentsIntegrationsMethodMappingRequest[];
}

export interface XeroConfigurationSettingRequest {
  zomentum_key: string;
  xero_key: string;
}

export interface XeroSettingsRequest {
  configuration: XeroConfigurationSettingRequest[];
}

export interface XeroMappingView {
  configuration: QuickBookConfigurationView[];
}
